import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import {
  ExistingSession,
  Session,
} from 'constants/contents/special-monitoring';
import If from 'global/Common/If';

interface Props {
  session: Session | ExistingSession;
  idx: number;
  color: string;
  isExisting?: boolean;
}

export default function SessionItem({
  session,
  idx,
  color,
  isExisting = false,
}: Props) {
  const sessionContent = session as Session;

  return (
    <Flex
      justify="space-between"
      width="100%"
      // @ts-expect-error
      mt="14px"
      direction="column"
      key={`${sessionContent.session}-${idx + 1}-session-a`}
    >
      <Text size="12px" color={color} width="40px">
        Sesi {sessionContent.session}
      </Text>
      <Flex justify="space-between" width="100%">
        <Flex direction="column" width="98px">
          {/* @ts-expect-error */}
          <Text size="12px" color="#858585" mb="4px">
            Order Collection
          </Text>
          <Text size="12px" family="bold" color={color}>
            {sessionContent.orderCollection}
          </Text>
        </Flex>
        <If condition={!isExisting}>
          <Flex direction="column" width="98px">
            {/* @ts-expect-error */}
            <Text size="12px" color="#858585" mb="4px">
              Random Closing
            </Text>
            <Text size="12px" family="bold" color={color}>
              {sessionContent.randomClosing}
            </Text>
          </Flex>
          <Flex direction="column" width="98px">
            {/* @ts-expect-error */}
            <Text size="12px" color="#858585" mb="4px">
              Order Matching
            </Text>
            <Text size="12px" family="bold" color={color}>
              {sessionContent.orderMatching}
            </Text>
          </Flex>
        </If>
      </Flex>
    </Flex>
  );
}
